import { render, staticRenderFns } from "./JobFavorites.vue?vue&type=template&id=82b29d7a&scoped=true&"
import script from "./JobFavorites.vue?vue&type=script&lang=js&"
export * from "./JobFavorites.vue?vue&type=script&lang=js&"
import style0 from "./JobFavorites.vue?vue&type=style&index=0&id=82b29d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b29d7a",
  null
  
)

export default component.exports